
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  ExamV2Custom,
  StructExamQuestionCommentConfig
} from "@/lib/model/exambuilder/exam-v2";
import {
  QuestionV2Object,
  QuestionV2
} from "@/lib/model/exambuilder/question-v2";

class CommentRules {
  comment = ""; // 主答案字数限制
  appendWordLimit1 = 0; // 追问答案字数限制
  appendWordLimit2 = 0;
  appendWordLimit = 0;
  wordLimit = 0; // 主答案字数限制
  wordLimit1 = 0;
  wordLimit2 = 0;
}
@Component({})
export default class Comment extends Vue {
  @Prop({}) exam!: ExamV2Custom;

  unAiComment = true;
  dialogFormVisible = false;
  aiComment: any = [];
  selectedQuestionList: QuestionV2[] = [];
  form: any = {};

  @Watch("exam", { immediate: true })
  async getQuestionList(exam: ExamV2Custom) {
    if (exam.questionIdList && exam.questionIdList.length > 0) {
      const param = {
        questionIdList: exam.questionIdList,
        dimensionKeyFilterList: exam.dimensionKeyList
      };
      const qo2 = await QuestionV2Object.get(param);
      this.selectedQuestionList = qo2.list;
      if (this.selectedQuestionList.length < exam.questionIdList.length) {
        // 数据不一致，有题目被删除，需要重新生成题目list
        exam.questionIdList = this.selectedQuestionList.map(question => {
          return question.questionId;
        });
      }

      this.selectedQuestionList.sort((q1, q2) => {
        return (
          exam.questionIdList.indexOf(Number(q1.questionId)) -
          exam.questionIdList.indexOf(Number(q2.questionId))
        );
      });
      console.log(this.exam.examRandomConfigList);
      if (exam.isRandomQuestions === 1) {
        this.aiComment = exam.examRandomConfigList.map((el: any) => {
          el.isAi = el.isAudioQuestion() || el.isVideoQuestion();
          this.$set(
            el,
            "commentList",
            this.getCommentConfigList(el.examQuestionConfig.commentConfigList)
          );
          return el;
        });
        console.log(this.aiComment);
      } else {
        this.aiComment = this.selectedQuestionList.reduce(
          (pre: any[], q: QuestionV2) => {
            if (q.isVideoQuestion() || q.isMP3()) {
              const comment = exam.examQuestionConfigList.find(
                item => item.questionId === q.questionId
              );
              pre.push({
                isAi: true,
                questionId: q.questionId,
                desc: q.desc,
                descTextOnly: q.descTextOnly,
                isAppendAsk: q.isAppendAsk,
                commentList: comment
                  ? this.getCommentConfigList(comment.commentConfigList)
                  : []
              });
            }
            return pre;
          },
          []
        );
      }
    }
  }
  // 处理加载时的commentConfigList
  getCommentConfigList(list: StructExamQuestionCommentConfig[]) {
    if (!list.length) {
      list = [new StructExamQuestionCommentConfig()];
    }
    return list.map(item => {
      return {
        comment: item.comment,
        appendWordLimit1: item.appendWordLimit[0] || 0,
        appendWordLimit2: item.appendWordLimit[1] || 0,
        wordLimit1: item.wordLimit[0] || 0,
        wordLimit2: item.wordLimit[1] || 0
      };
    });
  }
  // 添加评价规则
  addCommentRule(id: string, index?: number) {
    if (this.exam.isRandomQuestions === 1) {
      console.log(index);
      this.aiComment.forEach((el: any, zindex: number) => {
        if (zindex === index) {
          el.commentList.push(new CommentRules());
        }
      });
    } else {
      const currentComment = this.aiComment.find(
        (item: any) => item.questionId === id
      );
      if (currentComment) {
        currentComment.commentList.push(new CommentRules());
      }
    }
  }
  // 删除评价规则
  deleteCommentRule(id: string, index: number, groupI?: number) {
    if (this.exam.isRandomQuestions === 1) {
      this.aiComment.forEach((el: any, zindex: number) => {
        if (zindex === groupI) {
          el.commentList.splice(index, 1);
        }
      });
    } else {
      const currentComment = this.aiComment.find(
        (item: any) => item.questionId === id
      );
      if (currentComment) {
        currentComment.commentList.splice(index, 1);
      }
    }
  }
  returnQuestionTitle(questionId: number) {
    const item = this.selectedQuestionList.filter(
      (el: any) => el.questionId === questionId
    );
    if (item && item.length > 0) {
      return item[0].descTextOnly;
    } else {
      return "";
    }
  }
  // 输入内容处理
  inputChange(value: string, type: number, commentItem?: any, key?: string) {
    if (type && key) {
      //数字
      const v1 = (commentItem[key + 1] = Math.ceil(+commentItem[key + 1]));
      const v2 = (commentItem[key + 2] = Math.ceil(+commentItem[key + 2]));
      if (v2 < v1) {
        commentItem[key + 2] = v1;
      }
    } else {
      //文本域
      if (!value.length) {
        this.$message.warning("评价内容不能为空！");
      }
    }
  }
  // 存在音视频题AI评价
  get videoAndAudio() {
    return this.selectedQuestionList.some((q: QuestionV2) => {
      return q.isVideoQuestion() || q.isMP3();
    });
  }
  setComment() {
    this.dialogFormVisible = true;
  }
  // 评价规则配置保存
  commentSubmit() {
    this.aiComment.forEach((item: any, index: number) => {
      if (this.exam.isRandomQuestions !== 1) {
        const question = this.exam.examQuestionConfigList.find(
          comment => comment.questionId === item.questionId
        );
        if (question) {
          question.commentConfigList = item.commentList.reduce(
            (pre: StructExamQuestionCommentConfig[], cur: CommentRules) => {
              const questionComment = new StructExamQuestionCommentConfig();
              const {
                comment,
                appendWordLimit1,
                appendWordLimit2,
                wordLimit1,
                wordLimit2
              } = cur;
              if (comment.length) {
                questionComment.comment = comment;
                questionComment.appendWordLimit =
                  +appendWordLimit1 === 0 && +appendWordLimit2 === 0
                    ? []
                    : [+appendWordLimit1, +appendWordLimit2];
                questionComment.wordLimit =
                  +wordLimit1 === 0 && +wordLimit2 === 0
                    ? []
                    : [+wordLimit1, +wordLimit2];
                pre.push(questionComment);
              }

              return pre;
            },
            [] as StructExamQuestionCommentConfig[]
          );
        }
      } else {
        this.exam.examRandomConfigList.forEach((el, zindex: number) => {
          if (zindex === index) {
            el.examQuestionConfig.commentConfigList = item.commentList.reduce(
              (pre: StructExamQuestionCommentConfig[], cur: CommentRules) => {
                const questionComment = new StructExamQuestionCommentConfig();
                const {
                  comment,
                  appendWordLimit1,
                  appendWordLimit2,
                  wordLimit1,
                  wordLimit2
                } = cur;
                if (comment.length) {
                  questionComment.comment = comment;
                  questionComment.appendWordLimit =
                    +appendWordLimit1 === 0 && +appendWordLimit2 === 0
                      ? []
                      : [+appendWordLimit1, +appendWordLimit2];
                  questionComment.wordLimit =
                    +wordLimit1 === 0 && +wordLimit2 === 0
                      ? []
                      : [+wordLimit1, +wordLimit2];
                  pre.push(questionComment);
                }

                return pre;
              },
              [] as StructExamQuestionCommentConfig[]
            );
          }
        });
      }
    });
    this.dialogFormVisible = false;
  }
}
